import { SENS_ACHAT } from '@/configuration/devisConf';
import { PAIEMENT } from '@/configuration/mouvementClient/mouvementClientConf';
import moment from 'moment';

export default function genererCritereRechercheJournalPaiements(moduleDcf) {
  return {
    auto: null,
    societeId: null,
    sensPiece: SENS_ACHAT,
    typesPiece: [PAIEMENT],
    dates: {
      dateDebut: (moment().startOf('month')).toDate(),
      dateFin: (moment().endOf('month')).toDate(),
    },
    borneDebit: {
      borneMin: null,
      borneMax: null,
    },
    tiersIds: [],
    domiciliationBancaireIds: [],
    referencePaiement: null,
    emetteur: null,
    payeurs: null,
    codeFactureOuContrat: null,
    module: moduleDcf,
    modeDeReglementIds: [],
  };
}
